import { getQbeTrack } from '../configs/qbeTrack';
import { AnalyticsConfig } from '../types';
import { setAnalytics } from '../utils/analyticsUtils';

// TODO - Form Start Engagement Tracking Flag
// const isFormInputEvent = (item) => (fn) =>
//   item.event === 'form-input' ? fn(item) : true;

const sendToDataLayer = (payload: object, config: AnalyticsConfig) => {
  setAnalytics(payload);

  // Unit Test Mode
  if (config?.unitTestMode) {
    const qbeTrack = getQbeTrack();
    qbeTrack.test.dataLayer.push(payload);
    return false;
  }

  // MFE Condition.
  if (config.analyticsDataObject?.activePagePath) {
    config.cache.set(payload, config.dataLayerName);
    return config.analyticsDataObject.dataLayer.push(payload);
  }
  if (window.dataLayer) {
    config.cache.set(payload, config.dataLayerName);
    return window.dataLayer.push(payload);
  }
  return config.analyticsDataObject.dataLayer.push(payload);

  // Push the Current dqueue into Session Storage datalayer.
  // config.cache.set(config.analyticsDataObject, config.dataLayerName);
};

export default sendToDataLayer;
